import { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import './index.scss';
import UserInfoTab from "../../components/UserInfoTab";
import RadioButton from "../../components/RadioButton";
import ScheduleTable from "../../components/ScheduleTableTab";
import StudentsTab from "../../components/StudentsTab";
import Spinner from 'react-bootstrap/Spinner';
import { tabSwitcher } from "../../constants/variables";
import { useDispatch, useSelector } from "react-redux";
import { history } from '../../App';
import stylesScss from './index.module.scss';
import { BsArrowLeft } from 'react-icons/bs';
import { selectAll as selectAllTeachers } from '../../redux/slices/teachers.slice';
import { selectAll as selectAllLevels } from '../../redux/slices/levels.slice';
import { selectAll as selectAllStyles } from '../../redux/slices/styles.slice';
import { addChosenBoard } from '../../redux/slices/boards.slice.js';
import { eventsSetAll } from '../../redux/slices/events.slice';
import { studioSetAll } from '../../redux/slices/studio.slice';
import { Button } from "react-bootstrap";
import { modalEdit } from "../../redux/slices/modal.slice";
import { naturalSort } from "../../utilities";
import { filterSetAll } from "../../redux/slices/scheduleFilters.slice";

const INFO_TAB = "Info";
const SCHEDULE_TAB = "Schedule";
const STUDENTS_TAB = "Students";

function UserOverview({ isDefaultScreen, changeIsDefaultScreen }) {
    const params = useParams();
    const { isAdmin, id, studioName, email } = useSelector(state => state.personality.user)
    const isSuperAdmin = email === 'andrew@studioshuffle.com'  
    const path = history.location.pathname.slice(1);
    const teacher = useSelector(selectAllTeachers);
    const levels = useSelector(selectAllLevels);
    const styles = useSelector(selectAllStyles);
    const { loadingOneUser } = useSelector(state => state.users);
    const { loadingAllOptions, errorAllOptions } = useSelector(state => state.status);
    const [board, setBoard] = useState({});
    const [jumpTarget, setJumpTarget] = useState(null);
    const [currentTab, setTab] = useState(path === 'profile' ? tabSwitcher[0].label : tabSwitcher[1].label);
    const { chosenUser } = useSelector(state => state.users);
    const dispatch = useDispatch();

    useEffect(() => {
      setTab(path === 'profile' ? tabSwitcher[0].label : tabSwitcher[1].label);
    }, [path])

    useEffect(() => {
      dispatch({ type: "OPTIONS_GET_ALL", payload: { userId: isAdmin ? params.id : id } })
      dispatch({ type: "BOARDS_GET_ALL", query: { userId: isAdmin ? params.id : id } })
      setBoard(null);
      if (isAdmin && !chosenUser) {
        dispatch({ type: "GET_ONE_USER", payload: { userId: params.id || localStorage.getItem('userId') } });
      }
      return () => {
        changeIsDefaultScreen(true)
      }
    }, [params.id]);

    const sortedTeachers = naturalSort(teacher, 'teacherName');
    const sortedLevels = naturalSort(levels, 'levelName');
    const sortedStyles = naturalSort(styles, 'styleName');
    const data = { Teachers: sortedTeachers, Levels: sortedLevels, Styles: sortedStyles };
    const userStudioName = studioName ? `[${studioName}]` : '';
    const userHeaderName = path === 'profile' ? 'Profile' : `${userStudioName} My Schedules`
    const userHeaderAdmin = params.id ? `${chosenUser?.name || 'User - #' + params.id}` : "My Schedules";

    const onBordAdd = () => {
      dispatch(modalEdit('BoardsAdd'));
    }

    const onBordEdit = useCallback(() => {
      if (!board) return;

      if (board.boardName) {
          dispatch(addChosenBoard(board));
          dispatch(modalEdit('BoardsEdit'));
      }
    }, [board, dispatch]);

    useEffect(() => {
      dispatch(eventsSetAll({ studios: [], boardDays: {} }));
      dispatch(studioSetAll([]));
      dispatch(filterSetAll(null));
    }, [params.id, dispatch]);
    
    return (<>
      {!loadingAllOptions && !loadingOneUser ? (<>
          <div className="mainContainer">
            <div className={stylesScss.buttons}>
              {/* Left: title + schedule actions */}
              <div className={stylesScss.titleArea}>
                {isAdmin ? <BsArrowLeft onClick={() => history.push('/users')} style={{ cursor: 'pointer' }} /> : null}
                <span className={stylesScss.pageTitle}>{isAdmin ? userHeaderAdmin : userHeaderName}</span>
                {currentTab === tabSwitcher[1].label && (
                  <>
                    <button onClick={onBordEdit} className={stylesScss.scheduleHeaderBtn}>
                      ✎ Edit
                    </button>
                    <button onClick={onBordAdd} className={stylesScss.scheduleHeaderBtn}>
                      + New
                    </button>
                  </>
                )}
              </div>
              {/* Center: tabs */}
              <div className="tabsContainer">
                {tabSwitcher
                  .filter(item => isSuperAdmin || item.label !== 'Info')
                  .map((item, idx) => (
                  <RadioButton key={`tabSwitcher-${idx}`} onChangeHandle={setTab} value={item.value}
                    uniqId={`tabSwitcher-${idx}`} activeValue={currentTab} size={"md"}>
                    {item.label}
                  </RadioButton>
                ))}
              </div>
              {/* Right: full screen */}

            </div>
          {currentTab === INFO_TAB ? (
            <UserInfoTab data={data} />
          ) : currentTab === SCHEDULE_TAB ? (
            <ScheduleTable board={board} setBoard={setBoard} jumpTarget={jumpTarget} onJumpHandled={() => setJumpTarget(null)}/>
          ) : (
            <StudentsTab onJumpToClass={(target) => {
              setTab(SCHEDULE_TAB);
              setJumpTarget(target);
            }} />
          )}
        </div>
      </>) : (
        <div className={stylesScss.spinnerWrapper}>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
      {errorAllOptions ? (<div className={stylesScss.spinnerWrapper}>
        <div className="text-danger">{errorAllOptions}</div>
      </div>) : null}
    </>
  );
}

export default UserOverview;